import { Box, Flex, Text, useBreakpointValue, useDisclosure } from '@chakra-ui/react'
import { ReactNode } from 'react'
import FaqModal from '../modals/FaqModal'
import { cdn } from '../../../utils/cdn'

const AuthWrapper = ({ children }: { children: ReactNode }) => {
  const { isOpen: isFaqModalOpen, onClose: onCloseFaqModal } = useDisclosure()
  const isMobile = useBreakpointValue({ base: true, md: false }, { ssr: false })

  if (isMobile) {
    return (
      <Flex w="100%" minH="100dvh" bg="white" pos="relative" direction="column">
        <FaqModal isOpen={isFaqModalOpen} onClose={onCloseFaqModal} />
        {children}
      </Flex>
    )
  }
  return (
    <Flex w="100%" h="100vh" pos="relative">
      <FaqModal isOpen={isFaqModalOpen} onClose={onCloseFaqModal} />
      <Box w="50%" h="100%" p="40px 60px" bg="white">
        <Box
          bgImage={`url('${cdn('/logo/blue-md.svg')}')`}
          w="100px"
          h="40px"
          bgPos="center"
          bgSize="contain"
          bgRepeat="no-repeat"
          mb="40px"
        />
        <Box h="calc(100% - 80px)" w="100%" p={{ md: '20px 30px', '2xl': '40px 120px' }} overflowY="auto">
          {children}
        </Box>
      </Box>
      <Box
        w="50%"
        bgImage={`url('${cdn('/background/auth.jpg')}')`}
        bgPos="center"
        bgSize="cover"
        pos="relative"
      >
        <Box w="100%" h="320px" pos="absolute" bottom="0" bgGradient="linear(to-t, rgba(0,0,0,1), transparent)" />
        <Text textStyle="h3" color="white" pos="absolute" bottom="120px" w="100%" p="0px 56px">
          Ocean by React
        </Text>
        <Text textStyle="b-md" color="white" pos="absolute" bottom="70px" fontWeight="400" w="100%" p="0px 56px">
          The future of collaboration and automation in online enforcement.
        </Text>
      </Box>

      <Flex pos="absolute" bottom="20px" w="50%" justifyContent="center" alignItems="center" gap="8px">
        <Text textStyle="b-xs" color="neutral.500" mt="3px">
          © 2025 Ocean, Inc. All rights reserved.
        </Text>
      </Flex>
    </Flex>
  )
}

export default AuthWrapper
